/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Parts from "App/model/parts/parts";
import {RenderElement} from "App/model/elements/element";

export default
class PartsPair extends Parts {
    constructor() {
        super();
    }

    public setParsedShapesIDToElementMapping(aElement: RenderElement) {
        let model = aElement.getModel();
        for (let i = 0; i < this._values.length; i++) {
            model.addShapeIDToElementMapping(this._values[i][0], aElement);
        }
    }
}
